export const isFormCompleted = (form) => {
  const keys = Object.keys(form);
  const values = Object.values(form);

  const filledKeys = keys.filter((key, i) => values[i] && values[i].length);

  return filledKeys.length === keys.length;
};
